module.exports = __webpack_public_path__ + "img/59_4.d384d765.png";